"use client";

import { useState } from "react";
import { useProfileContext } from "../../context/ProfileContext";
import LeftComponent from "../home/_components/LeftComponent";
import { X } from "lucide-react";

const GuestSignIn = () => {
  const { handleProfileSelect, logout } = useProfileContext();

  const [name, setName] = useState("");
  const [classId, setClassId] = useState<number | "">("");
  const [error, setError] = useState("");

  const handleSignIn = async () => {
    setError("");

    if (!name.trim() || !classId) {
      setError("Please fill in all fields.");
      return;
    }

    // Guest profile – not saved to DB
    const guestProfile = {
      studentId: -1,
      studentName: name.trim(),
      classId: Number(classId),
      isGuest: true,
    };

    await handleProfileSelect(guestProfile);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-300 via-pink-200 to-yellow-200 overflow-hidden relative">
      <div className="container mx-auto px-4 py-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-purple-700 mb-2">
            Sign In as a Guest
          </h1>
          <span className="text-5xl">🧸</span>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-center">
          <LeftComponent />

          <div className="bg-white/90 backdrop-blur-sm rounded-3xl p-8 shadow-xl border border-white/30">
            <div className="space-y-5">
              {/* Class Dropdown */}
              <div>
                <label className="block text-purple-700 font-bold text-lg mb-2">
                  Class
                </label>
                <select
                  value={classId}
                  onChange={(e) =>
                    setClassId(e.target.value ? Number(e.target.value) : "")
                  }
                  className="w-full p-3 rounded-xl border-2 border-purple-300 focus:border-purple-500 focus:outline-none text-gray-700 bg-white"
                >
                  <option value="">Select Your Class</option>
                  {[1, 2, 3, 4, 5].map((c) => (
                    <option key={c} value={c}>
                      Class {c}
                    </option>
                  ))}
                </select>
              </div>

              {/* Name */}
              <div>
                <label className="block text-purple-700 font-bold text-lg mb-2">
                  Name
                </label>
                <input
                  type="text"
                  placeholder="Enter your name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="w-full p-3 rounded-xl border-2 border-purple-300 focus:border-purple-500 focus:outline-none text-gray-700"
                />
              </div>

              {/* Error Message */}
              {error && (
                <div className="flex items-center gap-2 bg-red-100 border border-red-300 text-red-700 p-3 rounded-xl">
                  <span className="text-lg">😞</span>
                  <span className="flex-grow font-medium">{error}</span>
                  <button onClick={() => setError("")}>
                    <X className="w-5 h-5 text-red-500" />
                  </button>
                </div>
              )}

              {/* Sign In Button */}
              <button
                onClick={handleSignIn}
                className="w-full bg-gradient-to-r from-green-400 to-emerald-500 text-white text-xl font-bold py-4 rounded-2xl shadow-lg transform transition-all duration-300 hover:scale-105 hover:shadow-2xl cursor-pointer"
              >
                Sign In
              </button>

              {/* Back link */}
              <button
                onClick={logout}
                className="w-full text-purple-600 font-medium hover:text-purple-800 transition-colors cursor-pointer"
              >
                ← Back to Login
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuestSignIn;
